export default __webpack_public_path__ + "images/point-visible-icon.svg";